import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { useSnackbar } from "notistack";
// import { FaTrash } from "react-icons/fa";
// import { MdEditSquare } from "react-icons/md";
import AdminLoader from "../../components/common/loader/AdminLoader";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentPageTitle } from "../../store/slices/pageSlice";

import {
    getAllAssemblyInventory,
    createOrUpdateAssemblyInventory,
    deleteAssemblyInventory,
} from "../../store/slices/assemblyInventorySlice";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import CommaConvert from "../../utils/CommaConvert";
import { MdSearch } from "react-icons/md";
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import { importAssemblyInventory } from "../../store/slices/importAssemblyInventorySlice";
import { SquarePen, Trash2, Download, Upload } from "lucide-react";
import { useCurrencySymbol } from "../../utils/currencyUtils";
import ConfirmationModal from "../../components/common/confirm/ConfirmationModal";
import { useLoggedUser } from "../../utils/useLoggedUser";
import { getFeatureAccessLevel } from "../../utils/featureAccessUtils";

const Assembly = () => {
    const USAComma = CommaConvert();
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const [, setExcelData] = useState(null);
    const currency = useCurrencySymbol();
    const loggedUser = useLoggedUser();
    const hasNoFeatureConfig = !loggedUser?.featureAccess || loggedUser.featureAccess.length === 0;
    const assemblyAddLevel = getFeatureAccessLevel(loggedUser, "ASSEMBLY ADD ASSEMBLY");
    const assemblyEditLevel = getFeatureAccessLevel(loggedUser, "ASSEMBLY EDIT ASSEMBLY");
    const assemblyDownloadLevel = getFeatureAccessLevel(loggedUser, "ASSEMBLY DOWNLOAD ASSEMBLY");
    const assemblyUploadLevel = getFeatureAccessLevel(loggedUser, "ASSEMBLY UPLOAD ASSEMBLY");
    const assemblyAccessLevel = assemblyAddLevel || assemblyEditLevel || assemblyDownloadLevel || assemblyUploadLevel;
    const isViewOnly = !hasNoFeatureConfig && assemblyAccessLevel &&
        String(assemblyAccessLevel).trim().toUpperCase() === "VIEW ONLY";
    console.log("Assembly isViewOnly:", isViewOnly, "accessLevel:", assemblyAccessLevel, "hasNoFeatureConfig:", hasNoFeatureConfig);

    // "NO ACCESS" for *add* must disable the add form even when other permissions exist.
    const isAssemblyAddNoAccess =
        !hasNoFeatureConfig &&
        assemblyAddLevel &&
        String(assemblyAddLevel).trim().toUpperCase() === "NO ACCESS";

    const { inventory } = useSelector((state) => state.assemblyInventory);

    const [form, setForm] = useState({
        assembly: "",
        unitsAvailable: "",
        minimumquantity: "",
        partnumber: "",
        suppliername: "",
        unitprice: "0",
    });


    const [loading, setLoading] = useState(null);
    const [deleteId, setDeleteId] = useState(null);

    const [editingId, setEditingId] = useState(null);
    const isAddNoAccess = isAssemblyAddNoAccess && !editingId; // only block "Add" mode
    const isFormDisabled = isViewOnly || isAddNoAccess;
    const [searchQuery, setSearchQuery] = useState("");
    const [assemblyData, setAssemblyData] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [sortConfig, setSortConfig] = useState({
        key: null,
        direction: 'asc' // 'asc' or 'desc'
    });
    const SidebarGroup = useSelector((state) => state.sidebar.SidebarGroup);
    const groupsFromSlice = useSelector((state) => state.group?.group || []);
    const selectedSidebarGroupName = useMemo(() => {
        const selectedId = String(SidebarGroup || "").trim();
        if (!selectedId) return "";
        const matchedGroup = (Array.isArray(groupsFromSlice) ? groupsFromSlice : []).find((groupItem) => {
            const id = String(groupItem?._id ?? groupItem?.id ?? "").trim();
            return id === selectedId;
        });
        return String(
            matchedGroup?.name ??
            matchedGroup?.newGroupName ??
            matchedGroup?.groupName ??
            selectedId
        ).trim();
    }, [SidebarGroup, groupsFromSlice]);
    const isMatchingSidebarGroup = useCallback((groupValue) => {
        if (!SidebarGroup) return true;
        const normalizedGroupValue = String(groupValue ?? "").trim();
        return (
            normalizedGroupValue === String(SidebarGroup).trim() ||
            normalizedGroupValue === selectedSidebarGroupName
        );
    }, [SidebarGroup, selectedSidebarGroupName]);
    const getAssemblyGroupValue = useCallback((item) => {
        return item?.groupid ?? item?.groupId ?? item?.group;
    }, []);
    const [assemblydata, setAssemblydata] = useState([]);
    const dropdownsRef = useRef(null);
    const [openDropdownId, setOpenDropdownId] = useState(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            // If dropdown is open and click is outside the dropdown AND not on the dropdown icon
            if (openDropdownId && dropdownsRef.current && !dropdownsRef.current.contains(event.target)) {
                // Also check if the click was on the ellipsis icon itself
                const clickedElement = event.target;
                const isEllipsisIcon = clickedElement.closest('.dropdown-toggle-icon');

                if (!isEllipsisIcon) {
                    setOpenDropdownId(null);
                }
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [openDropdownId]);

    useEffect(() => {
        const filteredData = inventory.filter((item) =>
            isMatchingSidebarGroup(getAssemblyGroupValue(item))
        );
        setAssemblydata(filteredData)
    }, [inventory, SidebarGroup, isMatchingSidebarGroup, getAssemblyGroupValue]);
    console.log("ghdfhfdh", SidebarGroup)
    console.log("ghdhd assemblyData", assemblyData)
    const downloadExcel = () => {
        if (isViewOnly) return;
        const headings = [
            {
                "Assembly": "",
                "Units Available": "",
                "Minimum Quantity": "",
                "Group": selectedSidebarGroupName || SidebarGroup,
                "Part Number": "",
                [`Unit Cost ${currency}`]: "",
            },
        ];

        const ws = XLSX.utils.json_to_sheet(headings, { skipHeader: false });
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Sample File");
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const excelFile = new Blob([excelBuffer], {
            type: "application/octet-stream",
        });
        saveAs(excelFile, "Sample.xlsx");
    };

    useEffect(() => {
        dispatch(setCurrentPageTitle("Assembly"));
        dispatch(getAllAssemblyInventory());
    }, [dispatch]);


    // -----------------------------
    // FILTER DATA
    // -----------------------------


    // useEffect(() => {
    //     const filteredData = inventory?.filter((item) =>
    //         item.assembly.toLowerCase().includes(searchQuery.toLowerCase())
    //     );
    //     setAssemblyData(filteredData);
    // }, [inventory, searchQuery]);

    useEffect(() => {
        let filteredData = assemblydata?.filter((item) => {
            // If search query is empty, return all items
            if (!searchQuery.trim()) return true;

            const query = searchQuery.toLowerCase().trim();

            // Check multiple fields for the search query
            return (
                (item.assembly?.toLowerCase().includes(query)) ||
                (item.partnumber?.toString().toLowerCase().includes(query)) ||
                (item.suppliername?.toLowerCase().includes(query)) ||
                (item.unitsAvailable?.toString().includes(query)) ||
                (item.minimumquantity?.toString().includes(query)) ||
                (item.unitprice?.toString().includes(query))
            );
        }) || [];

        // Apply sorting if sortConfig is set
        if (sortConfig.key) {
            filteredData = [...filteredData].sort((a, b) => {
                let aValue = a[sortConfig.key];
                let bValue = b[sortConfig.key];

                // For string comparison
                if (sortConfig.key === 'assembly' || sortConfig.key === 'suppliername') {
                    aValue = aValue?.toLowerCase() || '';
                    bValue = bValue?.toLowerCase() || '';

                    if (aValue < bValue) {
                        return sortConfig.direction === 'asc' ? -1 : 1;
                    }
                    if (aValue > bValue) {
                        return sortConfig.direction === 'asc' ? 1 : -1;
                    }
                    return 0;
                }

                // For number comparison
                if (sortConfig.key === 'unitsAvailable' || sortConfig.key === 'minimumquantity' || sortConfig.key === 'partnumber' || sortConfig.key === 'unitprice') {
                    aValue = Number(aValue) || 0;
                    bValue = Number(bValue) || 0;

                    if (sortConfig.direction === 'asc') {
                        return aValue - bValue;
                    } else {
                        return bValue - aValue;
                    }
                }

                return 0;
            });
        }

        setAssemblyData(filteredData);
    }, [assemblydata, searchQuery, sortConfig]);

    const handleSort = (key) => {
        let direction = 'asc';

        // If clicking the same column, toggle direction
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        } else if (sortConfig.key === key && sortConfig.direction === 'desc') {
            // If clicking the same column for third time, remove sorting
            setSortConfig({ key: null, direction: 'asc' });
            return;
        }

        setSortConfig({ key, direction });
    };

    // Helper function to get sort icon state
    // const getSortIconState = (key) => {
    //     if (sortConfig.key === key) {
    //         return sortConfig.direction === 'asc' ? 'up' : 'down';
    //     }
    //     return null;
    // };

    // -----------------------------
    // INPUT HANDLERS
    // -----------------------------
    // const handleChange = (e) => {
    //     const { name, value } = e.target;

    //     if (name === "unitsAvailable") {
    //         if (!/^\d*$/.test(value)) return; // only numbers
    //     }

    //     setForm({ ...form, [name]: value });
    // };

    const handleChange = (e) => {
        if (isFormDisabled) return;
        const { name, value } = e.target;

        if (name === "unitsAvailable") {
            // Allow negative numbers, positive numbers, and empty string
            if (/^-?\d*$/.test(value) || value === "" || value === "-") {
                setForm({ ...form, [name]: value });
            }
        } else if (name === "minimumquantity") {
            if (!/^\d*$/.test(value)) return; // only numbers
            setForm({ ...form, [name]: value });
        } else if (name === "unitprice") {
            const rawValue = value.replace(/,/g, ""); // remove commas
            if (!/^\d*$/.test(rawValue)) return;
            setForm({ ...form, unitprice: rawValue });
        }
        else if (name === "partnumber") {
            // Allow only alphanumeric characters (letters and numbers)
            if (!/^[a-zA-Z0-9]*$/.test(value)) return;
            setForm({ ...form, [name]: value });
        } else if (name === "assembly" || name === "suppliername") {
            // Capitalize first letter
            const capitalizedValue = value.charAt(0).toUpperCase() + value.slice(1);
            setForm({ ...form, [name]: capitalizedValue });
        } else {
            setForm({ ...form, [name]: value });
        }
    };
    // -----------------------------
    // SUBMIT / UPDATE
    // -----------------------------
    const handleSubmit = async () => {
        if (isFormDisabled) return;
        if (!form.assembly.trim()) {
            enqueueSnackbar("Assembly Name is required", { variant: "error" });
            return;
        }
        if (!form.unitsAvailable) {
            enqueueSnackbar("Units Available is required", { variant: "error" });
            return;
        }
        if (!form.minimumquantity) {
            enqueueSnackbar("Minimum Quantity is required", { variant: "error" });
            return;
        }
        if (form.minimumquantity === "0" || form.minimumquantity === 0) {
            enqueueSnackbar("Minimum Quantity can't be Zero.", { variant: "error" });
            return;
        }
        if (!form.unitprice) {
            enqueueSnackbar("Unit Cost is required", { variant: "error" });
            return;
        }
        if (!form.partnumber) {
            enqueueSnackbar("Part number is required", { variant: "error" });
            return;
        }
        
        // Check for duplicate assembly (case-insensitive name + same part number)
        const duplicateAssembly = assemblydata.find((item) => {
            const sameName = item.assembly?.toLowerCase() === form.assembly.trim().toLowerCase();
            const samePartNumber = item.partnumber === form.partnumber;
            const sameGroup = isMatchingSidebarGroup(getAssemblyGroupValue(item));
            const isDifferentItem = editingId ? item._id !== editingId : true;
            
            return sameName && samePartNumber && sameGroup && isDifferentItem;
        });

        if (duplicateAssembly) {
            enqueueSnackbar("Assembly already exists.", { variant: "error" });
            return;
        }

        setLoading(true)
        try {
            let payload = [];

            if (editingId) {
                payload = [{ ...form, _id: editingId, groupid: SidebarGroup }];
            } else {
                payload = [{ ...form, groupid: SidebarGroup }];
            }

            await dispatch(createOrUpdateAssemblyInventory(payload)).unwrap();
            enqueueSnackbar(editingId ? "Assembly  Updated successfully!" : "Assembly  Added successfully!", {
                variant: "success",
            });

            dispatch(getAllAssemblyInventory());
            setForm({ assembly: "", unitsAvailable: "", minimumquantity: "", partnumber: "", suppliername: "", unitprice: "0" });
            setEditingId(null);
        } catch (error) {
            if (error.message === "Some assemblies already exist." && error.duplicates) {

                enqueueSnackbar("Same assembly already exist.", { variant: "error" });
            } else {
                // For other errors, show generic error message
                enqueueSnackbar("Error saving data", { variant: "error" });
            }
        } finally {
            setLoading(false)
        }
    };


    // -----------------------------
    // DELETE RECORD
    // -----------------------------
    const handleDelete = async (id) => {
        if (isViewOnly) return;
        setLoading(true);
        try {
            await dispatch(deleteAssemblyInventory(id)).unwrap();
            enqueueSnackbar("Assembly Deleted successfully!", { variant: "success" });



        } catch (error) {
            enqueueSnackbar("Error deleting record", { variant: "error" });
        } finally {
            if (assemblyData.length === 1) {
                setAssemblyData([])
            }
            setLoading(false);
            dispatch(getAllAssemblyInventory());
            setDeleteId(null);
            setIsModalOpen(false);
        }
    };


    // -----------------------------
    // EDIT RECORD
    // -----------------------------
    const handleEdit = (item) => {
        if (isViewOnly) return;
        setEditingId(item._id);
        setForm({
            assembly: item.assembly,
            unitsAvailable: item.unitsAvailable.toString(),
            minimumquantity: item.minimumquantity,
            partnumber: item.partnumber,
            suppliername: item.suppliername,
            unitprice: item.unitprice
        });
    };

    const handleCancel = () => {
        setEditingId(null);
        setForm({ assembly: "", unitsAvailable: "", minimumquantity: "", partnumber: "", suppliername: "", unitprice: "0" });
    };
    const handleFileChange = async (e) => {
        if (isViewOnly) return;
        const file = e.target.files[0];
        if (file) {
            const validTypes = [
                "application/vnd.ms-excel",
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            ];

            if (!validTypes.includes(file.type)) {
                enqueueSnackbar("Please upload a valid Excel file (.xls or .xlsx)", {
                    variant: "error",
                });
                e.target.value = "";
                return;
            }

            setExcelData(file);


            const formData = new FormData();
            formData.append("file", file);


            const result = await dispatch(importAssemblyInventory(formData));

            if (importAssemblyInventory.fulfilled.match(result)) {
                enqueueSnackbar("Excel File Data Added Successfully", {
                    variant: "success",
                });
                dispatch(getAllAssemblyInventory());

            } else {
                enqueueSnackbar("Failed to import Excel file.", { variant: "error" });
            }
            setExcelData(null)
        }
    };
    return (
        <div className="bg-[#f3f8f8] pb-6 h-full">
            <ConfirmationModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                onConfirm={() => handleDelete(deleteId)}
            />
            {loading ? (
                <AdminLoader isLoading={loading} />
            ) : (
                <div className="relative flex justify-center align-middle items-center pt-2">
                    <div className="flex w-[95%] gap-4">
                        {/* FORM */}
                        <div className="w-[35%] bg-white rounded-md h-fit">
                            <div className="flex px-3 py-4 gap-2 align-middle items-center border-b">
                                <span className="w-2 h-6 bg-blue-600 rounded-full"></span>
                                <h2 className="font-semibold text-xl">
                                    Add Assembly: {selectedSidebarGroupName || SidebarGroup}
                                </h2>
                            </div>
                            <fieldset disabled={isFormDisabled} className={isFormDisabled ? "opacity-90" : ""}>
                            <div className="mainform px-3 py-2 flex flex-col gap-3">

                                <div>
                                    <div className='flex gap-1 pb-2 text-xs align-middle items-center font-semibold'>
                                        Assembly Name <span className="text-red-700 text-xs">*</span>
                                    </div>
                                    <div>
                                        <input
                                            required
                                            className={`border w-full border-[#e5e7eb] rounded-md p-2 overflow-hidden outline-none text-xs ${isFormDisabled ? "bg-[#f3f4f6] cursor-not-allowed text-[#9ca3af]" : "bg-[#fcfcfc]"}`}
                                            type="text"
                                            name="assembly"
                                            value={form.assembly}
                                            disabled={isFormDisabled}
                                            onChange={handleChange}
                                            placeholder="Enter Assembly Name"
                                        />
                                    </div>
                                </div>
                                <div>
                                    <div className='flex gap-1 pb-2 text-xs align-middle items-center font-semibold'>
                                        Part Number <span className="text-red-700 text-xs">*</span>
                                    </div>
                                    <div>
                                        <input
                                            required
                                            className={`border w-full border-[#e5e7eb] rounded-md p-2 overflow-hidden outline-none text-xs ${isFormDisabled ? "bg-[#f3f4f6] cursor-not-allowed text-[#9ca3af]" : "bg-[#fcfcfc]"}`}
                                            type="text"
                                            name="partnumber"
                                            value={form.partnumber}
                                            disabled={isFormDisabled}
                                            onChange={handleChange}
                                            placeholder="Enter Part Number"
                                        />
                                    </div>
                                </div>
                                <div>
                                    <div className='flex gap-1 pb-2 text-xs align-middle items-center font-semibold'>
                                        Units Available <span className="text-red-700 text-xs">*</span>
                                    </div>
                                    <div>
                                        <input
                                            required
                                            className={`border w-full border-[#e5e7eb] rounded-md p-2 overflow-hidden outline-none text-xs ${isFormDisabled ? "bg-[#f3f4f6] cursor-not-allowed text-[#9ca3af]" : "bg-[#fcfcfc]"}`}
                                            type="text"
                                            name="unitsAvailable"
                                            value={form.unitsAvailable}
                                            disabled={isFormDisabled}
                                            onChange={handleChange}
                                            placeholder="Enter Units Available"
                                        />
                                    </div>
                                </div>
                                <div>
                                    <div className='flex gap-1 pb-2 text-xs align-middle items-center font-semibold'>
                                        Unit Cost ({currency}) <span className="text-red-700 text-xs">*</span>
                                    </div>
                                    <div>
                                        <input
                                            required
                                            className={`border w-full border-[#e5e7eb] rounded-md p-2 overflow-hidden outline-none text-xs ${isFormDisabled ? "bg-[#f3f4f6] cursor-not-allowed text-[#9ca3af]" : "bg-[#fcfcfc]"}`}
                                            type="text"
                                            name="unitprice"
                                            value={USAComma(form.unitprice)}
                                            disabled={isFormDisabled}
                                            onChange={handleChange}
                                            placeholder="0"
                                        />
                                    </div>
                                </div>
                                <div>
                                    <div className='flex gap-1 pb-2 text-xs align-middle items-center font-semibold'>
                                        Minimum Quantity <span className="text-red-700 text-xs">*</span>
                                    </div>
                                    <div>
                                        <input
                                            required
                                            className={`border w-full border-[#e5e7eb] rounded-md p-2 overflow-hidden outline-none text-xs ${isFormDisabled ? "bg-[#f3f4f6] cursor-not-allowed text-[#9ca3af]" : "bg-[#fcfcfc]"}`}
                                            type="text"
                                            name="minimumquantity"
                                            value={form.minimumquantity}
                                            disabled={isFormDisabled}
                                            onChange={handleChange}
                                            placeholder="Enter Minimum Quantity"
                                        />
                                    </div>
                                </div>
                                <div className="flex gap-2 text-xs">
                                    <button
                                        onClick={handleSubmit}
                                        disabled={isFormDisabled}
                                        className={`p-1 flex align-middle items-center gap-2 px-4 overflow-hidden rounded-lg ${isFormDisabled ? "opacity-60 cursor-not-allowed pointer-events-none bg-gray-300 text-[#9ca3af]" : "bg-[#0f61e6] hover:bg-blue-400 text-white"}`}
                                    >
                                        {editingId ? "Update" : "Submit"}
                                    </button>
                                    <button
                                        onClick={handleCancel}
                                        disabled={isFormDisabled}
                                        className={`py-2 px-3 border overflow-hidden rounded-lg ${isFormDisabled ? "opacity-60 cursor-not-allowed pointer-events-none border-gray-300 bg-gray-100 text-[#9ca3af]" : "border-[#e5e7eb] bg-white"}`}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                            </fieldset>
                        </div>

                        {/* TABLE */}
                        <div className="w-[65%] p-4 bg-white rounded-md">
                            <div className="flex justify-between align-middle items-center py-2 gap-3">
                                <div className="flex items-center gap-3 shrink-0">
                                    <span className="w-2 h-6 bg-blue-600 rounded-full"></span>
                                    <h1 className="text-lg font-semibold text-gray-900">
                                        Assembly Details: {selectedSidebarGroupName || SidebarGroup}
                                    </h1>
                                </div>

                                <div className="flex items-center gap-3 flex-wrap justify-end">
                                    <button
                                        onClick={downloadExcel}
                                        disabled={isViewOnly}
                                        className={`text-xs flex items-center justify-center px-3 py-2 rounded-lg ${isViewOnly ? "opacity-60 cursor-not-allowed pointer-events-none bg-gray-300 text-[#9ca3af]" : "bg-[#0f61e6] hover:bg-blue-400 text-white"}`}
                                        title="Download Template"
                                    >
                                        <Download size={16} />
                                    </button>

                                    <input
                                        type="file"
                                        accept=".xls,.xlsx"
                                        id="excel-upload"
                                        onChange={handleFileChange}
                                        disabled={isViewOnly}
                                        className="hidden"
                                    />

                                    <label
                                        htmlFor={isViewOnly ? undefined : "excel-upload"}
                                        className={`text-xs flex items-center justify-center px-3 py-2 border rounded-lg ${isViewOnly ? "opacity-60 cursor-not-allowed pointer-events-none border-gray-300 bg-gray-100 text-[#9ca3af]" : "border-[#e5e7eb] bg-white cursor-pointer hover:bg-gray-50"}`}
                                        title="Upload File"
                                    >
                                        <Upload size={16} />
                                    </label>

                                    <p className="text-xs text-red-700 whitespace-nowrap">
                                    (.xls/.xlsx)
                                    </p>

                                    <div className="flex gap-1 p-1 align-middle items-center border border-[#e5e7eb] rounded-lg w-[180px]">
                                        <MdSearch className="w-4 h-4 text-gray-500" />
                                        <input
                                            type="text"
                                            placeholder="Search"
                                            className="outline-none text-xs text-gray-900 placeholder-gray-500 w-full"
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                            <hr />
                            <hr />
                            <br />
                            <div className="maintable min-h-[10rem] max-h-[60vh] overflow-auto">

                                <table className="min-w-full divide-y divide-gray-200 border text-xs">
                                    <thead className="bg-[#e8e8e8] sticky top-0 z-50 font-semibold">
                                        <tr>
                                            <th className="border p-2 text-center tracking-wider font-medium capitalize">Sr. No</th>
                                            <th className="border p-2 text-start tracking-wider font-medium capitalize relative">
                                                <div className="flex justify-between items-center">
                                                    <span>Assembly Name</span>
                                                    <div className="flex flex-col">
                                                        <div
                                                            className="cursor-pointer"
                                                            onClick={() => handleSort("assembly")}
                                                        >
                                                            <ArrowDropUp sx={{ fontSize: "22px" }} />
                                                        </div>
                                                        <div
                                                            className="cursor-pointer -mt-2"
                                                            onClick={() => handleSort("assembly")}
                                                        >
                                                            <ArrowDropDown sx={{ fontSize: "22px" }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </th>
                                            <th className="border p-2 text-center tracking-wider font-medium capitalize relative">
                                                <div className="flex justify-center items-center gap-2">
                                                    <span>Part Number</span>
                                                    <div className="flex flex-col">
                                                        <div
                                                            className="cursor-pointer"
                                                            onClick={() => handleSort("partnumber")}
                                                        >
                                                            <ArrowDropUp sx={{ fontSize: "22px" }} />
                                                        </div>
                                                        <div
                                                            className="cursor-pointer -mt-2"
                                                            onClick={() => handleSort("partnumber")}
                                                        >
                                                            <ArrowDropDown sx={{ fontSize: "22px" }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </th>
                                            <th className="border p-2 text-center tracking-wider font-medium capitalize relative">
                                                <div className="flex justify-center items-center gap-2">
                                                    <span>Units Available</span>
                                                    <div className="flex flex-col">
                                                        <div
                                                            className="cursor-pointer"
                                                            onClick={() => handleSort("unitsAvailable")}
                                                        >
                                                            <ArrowDropUp sx={{ fontSize: "22px" }} />
                                                        </div>
                                                        <div
                                                            className="cursor-pointer -mt-2"
                                                            onClick={() => handleSort("unitsAvailable")}
                                                        >
                                                            <ArrowDropDown sx={{ fontSize: "22px" }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </th>
                                            <th className="border p-2 text-center tracking-wider font-medium capitalize relative">
                                                <div className="flex justify-center items-center gap-2">
                                                    <span>Unit Cost ($)</span>
                                                    <div className="flex flex-col">
                                                        <div
                                                            className="cursor-pointer"
                                                            onClick={() => handleSort("unitprice")}
                                                        >
                                                            <ArrowDropUp sx={{ fontSize: "22px" }} />
                                                        </div>
                                                        <div
                                                            className="cursor-pointer -mt-2"
                                                            onClick={() => handleSort("unitprice")}
                                                        >
                                                            <ArrowDropDown sx={{ fontSize: "22px" }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </th>
                                            <th className="border p-2 text-center tracking-wider font-medium capitalize relative">
                                                <div className="flex justify-center items-center gap-2">
                                                    <span>Minimum Quantity</span>
                                                    <div className="flex flex-col">
                                                        <div
                                                            className="cursor-pointer"
                                                            onClick={() => handleSort("minimumquantity")}
                                                        >
                                                            <ArrowDropUp sx={{ fontSize: "22px" }} />
                                                        </div>
                                                        <div
                                                            className="cursor-pointer -mt-2"
                                                            onClick={() => handleSort("minimumquantity")}
                                                        >
                                                            <ArrowDropDown sx={{ fontSize: "22px" }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </th>
                                            <th className="border p-2 text-center tracking-wider font-medium capitalize">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-gray-200">
                                        {assemblyData?.length > 0 ? (
                                            assemblyData?.map((item, index) => (
                                                <tr className="border border-gray-400" key={item._id}>
                                                    <td className="px-2 border-b text-center py-2">{index + 1}</td>
                                                    <td className="px-2 text-start border-b py-2">{item.assembly}</td>
                                                    <td className="px-2 text-center border-b py-2">{item.partnumber}</td>
                                                    <td className={`px-2 text-center border-b py-2 ${parseInt(item.unitsAvailable) < 0 ? 'text-red-500' : ''}`}>
                                                        {USAComma(item.unitsAvailable)}
                                                    </td>
                                                    <td className="px-2 text-center border-b py-2">{USAComma(item.unitprice)}</td>
                                                    <td className="px-2 text-center border-b py-2">{USAComma(item.minimumquantity)}</td>
                                                    <td className="px-2 border-b text-center py-2">
                                                        <div className="flex justify-center items-center gap-3">
                                                            <div
                                                                onClick={() => handleEdit(item)}
                                                                className={isViewOnly ? "opacity-60 cursor-not-allowed pointer-events-none" : "cursor-pointer hover:opacity-70"}
                                                                title="Edit"
                                                            >
                                                                <SquarePen size={18} className={isViewOnly ? "text-[#9ca3af]" : "text-blue-500"} />
                                                            </div>
                                                            <div
                                                                onClick={() => {
                                                                    if (isViewOnly) return;
                                                                    setDeleteId(item._id);
                                                                    setIsModalOpen(true);
                                                                }}
                                                                className={isViewOnly ? "opacity-60 cursor-not-allowed pointer-events-none" : "cursor-pointer hover:opacity-70"}
                                                                title="Delete"
                                                            >
                                                                <Trash2 size={18} className={isViewOnly ? "text-[#9ca3af]" : "text-blue-500"} />
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="7" className="text-center text-red-500 py-4">
                                                    No matching records found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Assembly;
